import { useLocation } from 'react-router-dom';

import './screens.css';

export interface ScreenPlaceholderProps {
  /** The screen this route will hold, matching its top-bar title. */
  title: string;
}

/**
 * Phase 1 body for a routed screen.
 *
 * The route, its title and its place in the shell are real; the analytics,
 * tables and forms that fill it arrive in Stage 3 of the build playbook. This
 * is the single placeholder the playbook allows in Phase 1.
 */
export function ScreenPlaceholder({ title }: ScreenPlaceholderProps): React.JSX.Element {
  const location = useLocation();
  const query = location.search.replace(/^\?/, '');

  return (
    <section className="screen" aria-label={title}>
      <div className="screen-card">
        <p className="screen-card-body">
          This screen is routed and framed by the Docsight shell. Its data surfaces are built in a
          later phase of the playbook.
        </p>
        <dl className="screen-meta">
          <dt>Route</dt>
          <dd className="mono" data-testid="screen-route">
            {location.pathname}
          </dd>
          <dt>Query</dt>
          <dd className="mono" data-testid="screen-query">
            {query === '' ? '—' : query}
          </dd>
        </dl>
      </div>
    </section>
  );
}
